import * as layoutStyles from "../../styles/layout/layout.module.scss";

import Footer from "./desktop/Footer";
import FooterSmartphone from "./smartphone/Footer";
import Header from "./desktop/Header";
import Menu from "./smartphone/Menu";
import PropTypes from "prop-types";
import React from "react";
import ScrollToTop from "react-scroll-to-top";
import SiteNavigationHtml from "./desktop/SiteNavigationHtml";
import TransversalNavigationHtml from "./desktop/TransversalNavigationHtml";
import clsx from "clsx";
import {supportedLanguages} from "../../services/i18n";
import {useTranslation, getI18n} from "react-i18next";

const Layout = React.memo(function Layout({children, ...props}) {
    const {
        name, menu, logo, footer, locale, localizations, logoPartner, siteURL, corporateMenu, communityMenu,
    } = props;
    const {t} = useTranslation();
    const [displayNavigationLinks, setDisplayNavigationLinks] = React.useState(false);
    React.useEffect(() => {
        // remove tabIndex -1 for accessibility
        const gatsbyFocusWrapper = document.getElementById("gatsby-focus-wrapper");
        if (gatsbyFocusWrapper) {
            gatsbyFocusWrapper.removeAttribute("tabIndex");
        }
    }, []);

    return (<>
        <nav aria-label={t("accessibility.nav.label")}>
            <div
                className={displayNavigationLinks ? layoutStyles.accessibilityLinks : clsx(layoutStyles.accessibilityLinksHide, layoutStyles.accessibilityLinks)}
            >
                <ul>
                    <li>
                        <a
                            href="#content"
                            onFocus={() => setDisplayNavigationLinks(true)}
                        >
                            {t("skip.to.content")}
                        </a>{" "}
                        /
                    </li>
                    <li>
                        <a href="#surHeader">{t("skip.to.sur.header")}</a> /
                    </li>
                    <li>
                        <a
                            href="#navigation"
                            onFocus={() => setDisplayNavigationLinks(true)}
                        >
                            {t("skip.to.main.navigation")}
                        </a>{" "}
                        /
                    </li>
                    <li>
                        <a
                            href="#searchForm"
                            onBlur={() => setDisplayNavigationLinks(false)}
                        >
                            {t("skip.to.search.form")}
                        </a>{" "}
                        /
                    </li>
                    <li>
                        <a
                            href="#footer"
                            onFocus={() => setDisplayNavigationLinks(true)}
                            onBlur={() => setDisplayNavigationLinks(false)}
                        >
                            {t("skip.to.footer")}
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
        <div className={layoutStyles.rootNav}>
            <nav
                className={layoutStyles.desktop}
                id="surHeader"
                aria-label={t("transversalNav.label")}
            >
                {/*<TransversalNavigation
            websiteRoot={siteURL}
            localizations={localizations}
            corporateMenu={corporateMenu}
            locale={locale}
        />*/}
                <TransversalNavigationHtml
                    websiteRoot={siteURL}
                    localizations={localizations}
                    corporateMenu={corporateMenu}
                    locale={locale}
                />
            </nav>
            <Header
                menu={menu}
                name={name}
                logo={logo}
                locale={locale}
                localizations={localizations}
                logoPartner={logoPartner}
                communityMenu={communityMenu}
                styleClass={layoutStyles.desktop}
            />
            <nav
                className={clsx(layoutStyles.desktop, layoutStyles.layoutContainer, layoutStyles.headerContainer)}
            >
                {/*<SiteNavigation
              menu={menu}
              siteURL={siteURL}
              locale={locale}
              localizations={localizations}
              item
          ></SiteNavigation>*/}
                <SiteNavigationHtml
                    menu={menu}
                    siteURL={siteURL}
                    locale={locale}
                    localizations={localizations}
                    item
                />
            </nav>
            <nav className={layoutStyles.smartphone}>
                <Menu
                    menu={menu}
                    name={name}
                    logo={logo}
                    siteURL={siteURL}
                    languages={supportedLanguages}
                    currentLocale={getI18n().language}
                    locale={locale}
                    localizations={localizations}
                    logoPartner={logoPartner}
                    communityMenu={communityMenu}
                    corporateMenu={corporateMenu}
                />
            </nav>
            <main id="content" style={{width: "100%"}}>
                {children}
                {<ScrollToTop
                    aria-label={t("scrollToTop.label")}
                    smooth
                    color={"white"} className={layoutStyles.scrollToTopClass}
                />}
            </main>

            <div
                id="footer"
                role="contentinfo">
                <div
                    className={clsx(layoutStyles.footer, layoutStyles.desktop)}
                >
                    <Footer footer={footer} locale={locale}/>
                </div>
                <div
                    className={clsx(layoutStyles.footer, layoutStyles.smartphone)}
                >
                    <FooterSmartphone footer={footer} locale={locale}/>
                </div>
            </div>
        </div>
    </>);
});

export default Layout;

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};
